import React from 'react';

const Column = React.forwardRef(({ style, className, dataId, onDragColumn, children }, ref) => {
    const handleDragStart = (e) => {
        e.dataTransfer.setData('text/plain', '');
        onDragColumn(dataId);
    };

    return (
        <div
            style={style}
            className={className}
            ref={ref}
            draggable
            onDragStart={handleDragStart}
        >
            {children}
        </div>
    );
});

export default Column;